import { render, staticRenderFns } from "./AddressPanel.vue?vue&type=template&id=3240489d&"
import script from "./AddressPanel.vue?vue&type=script&lang=js&"
export * from "./AddressPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports